/**
 * View component for /resource-links/:resourceLinkId
 *
 * Displays a single resourceLink from the 'byId' map in the resourceLink reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as resourceLinkActions from '../resourceLinkActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import resourceLink components
import ResourceLinkLayout from '../components/ResourceLinkLayout.js.jsx';

// import resourceLink css modules
import resourceLinkStyles from '../resourceLinkModuleStyles.css';


class SingleResourceLink extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(resourceLinkActions.fetchSingleIfNeeded(match.params.resourceLinkId));
  }

  render() {
    const { resourceLinkStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual resourceLink object from the map
     */
    const selectedResourceLink = resourceLinkStore.selected.getItem();

    const isEmpty = (
      !selectedResourceLink
      || !selectedResourceLink._id
      || resourceLinkStore.selected.didInvalidate
    );

    return (
      <ResourceLinkLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h3> Single Resource Link </h3>
              {isEmpty ?
                (resourceLinkStore.selected.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: resourceLinkStore.selected.isFetching ? 0.5 : 1 }}>
                  <h1> { selectedResourceLink.name }
                    <Link className="yt-btn small u-pullRight" to={`${this.props.match.url}/update`}> UPDATE Resource Link </Link>
                  </h1>
                  <hr/>
                  <p> <em>Other characteristics about the ResourceLink would go here.</em></p>
                </div>
              }
            </div>
          </section>
        </div>
      </ResourceLinkLayout>
    )
  }
}

SingleResourceLink.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    resourceLinkStore: store.resourceLink
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleResourceLink)
);



// WEBPACK FOOTER //
// modules/resourceLink/views/SingleResourceLink.js.jsx